import React from 'react';
import * as PropTypes from 'prop-types';
import { getResizedImageDetails } from '@ifit/mary-poppins/dist/shared/index';

export class TrainerDisplayWrapper extends React.Component {
  resizeTrainerImage(image) {
    const avatarSize = 44;
    return getResizedImageDetails(
      {
        width: avatarSize,
        height: avatarSize,
      },
      {
        useStandardDimensions: false,
      },
      image,
    ).image;
  }

  render() {
    const { name, img } = this.props;
    return (
      <div className="display-wrapper">
        <img
          loading="lazy"
          decoding="async"
          src={this.resizeTrainerImage(img)}
          alt="iFIT Trainers"
          width="24"
          height="24"
        />
        {name}
      </div>
    );
  }
}
TrainerDisplayWrapper.propTypes = {
  name: PropTypes.string,
  img: PropTypes.string,
};

export default TrainerDisplayWrapper;
